export default "__VITE_ASSET__AuvrVA1n__"